import { MS_24_HOURS } from '@libs/constants/app.constants';
import { range } from 'lodash';
export const GetTimestampMonthStart = (ts: number): number => {
  const date = new Date(ts);
  const ld = new Date(date.getFullYear(), date.getMonth(), 0);
  return ld.getTime() + MS_24_HOURS;
};
export const LastDayOfMonth = (ts, end_of_day?: boolean): number => {
  const date = new Date(ts);
  const ld = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  const _ts = ld.getTime();
  return end_of_day ? _ts + MS_24_HOURS : _ts;
};
export const GetMothInterval = (ts: number): number[] => [GetTimestampMonthStart(ts), LastDayOfMonth(ts, true)];
export const GetTimestamp00Hours = (timestamp: number): number => {
  const date: Date = new Date(
    `${new Date(+timestamp).getMonth() + 1}/${new Date(+timestamp).getDate()}/${new Date(+timestamp).getFullYear()}`,
  );
  const offset: number = date.getTimezoneOffset() * 60 * 1000;
  return date.getTime() - offset;
};
export const GetTimestamp_x_DaysAgo = (timstamp: number, days: number): number => timstamp - days * MS_24_HOURS;
export const DaysInMonth = (month: number, year: number) => new Date(year, month, 0).getDate();

export const GetBrazilOffset = (): number => {
  const nDate = new Date().toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' });
  const splitted = nDate.split(',');
  const hour_complete = splitted[1].split(':');
  const isPm = splitted[1].substr(-2) == 'PM';
  return new Date().getHours() - (Number(hour_complete[0]) + (isPm ? 12 : 0));
};
export const GetTimezoneOffset = (): number => {
  function z(n) {
    return (n < 10 ? '0' : '') + n;
  }
  var offset = new Date().getTimezoneOffset();
  var sign = offset < 0 ? '+' : '-';
  offset = Math.abs(offset);
  const res = sign + z((offset / 60) | 0) + z(offset % 60);
  return +res / 100;
};
export const Month_intervals_year_timestamps = (year: number) =>
  range(12).map(month => [new Date(year, month, 1).getTime(), new Date(year, month + 1, 0).getTime() + MS_24_HOURS]);

export const ConvertToDate = (dateString: string): Date => {
  //  Convert a "dd/MM/yyyy" string into a Date object
  let d = dateString.split('/');
  return new Date(d[2] + '/' + d[1] + '/' + d[0]);
};
export const FormatStripDate = stripDate => {
  return `${stripDate.substr(0, 2)}/${stripDate.substr(2, 2)}/${stripDate.substr(4, 4)}`;
};
export const FormatDate = (date: Date) => {
  return date.toISOString().split('T')[0];
};
export const HasMore18 = (date: string) => {
  // dd/mm/yyyy
  const [day, month, year] = date.split('/');
  const minDate = new Date(`${month}/${day}/${+year + 18}`);
  return Date.now() > minDate.getTime();
};
export const GetTimestampsOfMonthYear = (month: number, year: number): number[] => {
  month -= 1;
  const timestamps = [];
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  for (let day = 1; day <= daysInMonth; day++) {
    const date = new Date(year, month, day);
    timestamps.push(GetTimestamp00Hours(date.getTime()));
  }
  return timestamps;
};
export function converterDataParaTimestamp(dataString) {
  // Divide a data em partes [dd, mm, yyyy]
  var partes = dataString.split('-');

  // JavaScript espera o mês no formato 0-11, onde 0 é Janeiro
  // Então subtraímos 1 do mês
  var dia = parseInt(partes[0], 10);
  var mes = parseInt(partes[1], 10) - 1;
  var ano = parseInt(partes[2], 10);

  // Cria a data em UTC
  var dataUTC = Date.UTC(ano, mes, dia);

  // Retorna o timestamp
  return dataUTC;
}
